import { Building2, GraduationCap, Store, Tractor, Home } from 'lucide-react';

// Configuration des secteurs avec icônes
export const SECTEURS = {
  "Habitat": { icon: Home, color: "from-blue-500 to-cyan-500", bgColor: "bg-blue-500", textColor: "text-blue-600" },
  "BTP": { icon: Building2, color: "from-amber-500 to-orange-500", bgColor: "bg-amber-500", textColor: "text-amber-600" },
  "Agriculture": { icon: Tractor, color: "from-green-500 to-emerald-500", bgColor: "bg-green-500", textColor: "text-green-600" },
  "Commerce": { icon: Store, color: "from-purple-500 to-violet-500", bgColor: "bg-purple-500", textColor: "text-purple-600" },
  "Formation": { icon: GraduationCap, color: "from-pink-500 to-rose-500", bgColor: "bg-pink-500", textColor: "text-pink-600" }
};

// Configuration des territoires
export const TERRITOIRES = {
  "Guadeloupe": { icon: "🏝️", code: "971" },
  "Martinique": { icon: "🌴", code: "972" },
  "Guyane": { icon: "🌿", code: "973" },
  "France Hexagonale": { icon: "🇫🇷", code: "FR" }
};

// Configuration des types d'acteurs
export const TYPES_ACTEURS = {
  "Particulier": { icon: "👤", description: "Personne physique" },
  "TPE": { icon: "🏢", description: "Très petite entreprise" },
  "Exploitant": { icon: "🚜", description: "Exploitant agricole" },
  "Association": { icon: "🤝", description: "Structure associative" }
};

// Durées disponibles
export const DUREES = [
  { mois: 60, label: "5 ans" },
  { mois: 120, label: "10 ans" },
  { mois: 180, label: "15 ans" },
  { mois: 240, label: "20 ans" },
  { mois: 300, label: "25 ans" }
];
